import { BottomTabBar } from './BottomTabBar'
import { Sidebar } from './Sidebar'
import { useAppStore, selectMobileMenuOpen } from '@/shared/stores/appStore'
import styles from './AppShell.module.css'

export function AppShell({ children }: React.PropsWithChildren) {
  const mobileMenuOpen = useAppStore(selectMobileMenuOpen)
  const setMobileMenuOpen = useAppStore((s) => s.setMobileMenuOpen)

  return (
    <div className={styles.shell}>
      {/* Desktop: icon rail / full sidebar. Mobile: hidden until opened as a drawer
          via the AppHeader hamburger. */}
      <Sidebar mobileOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />

      <div className={styles.content}>
        {children}
      </div>

      {/* CSS hides this above 1024px — sidebar takes over */}
      <BottomTabBar />
    </div>
  )
}
